// import React ,{useState}from "react";
// import SearchBar from "../../components/universal/SearchBar";
// import { allchurchHeader } from "./Constants";
// import CustomTable from "../../components/universal/CustomTable";
// import { AiOutlinePlus } from "react-icons/ai";
// import { Link, useNavigate,useLocation } from "react-router-dom";
// import { AllChurchHooks } from "./hooks/Churchhooks";
// import Navbar from "../../components/universal/Navbar";
// import { confirmAlert } from "react-confirm-alert"; // Import
// import "react-confirm-alert/src/react-confirm-alert.css";
// import ConfirmToast from "../../components/universal/ConfirmToast";
// import LoaderSpinner from "../../components/universal/LoaderSpinner";
// import { useSelector } from "react-redux";
// import ChurchModal from "./ChurchModal";
// function AllVideos() {
//   const navigate = useNavigate();
//   const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData,fetchAllChurches } =
//   AllChurchHooks();
//   const [isModalOpen, setIsModalOpen] = useState(false); // ✅ modal state
//   const [selectedRow, setSelectedRow] = useState(null); // store clicked row
//      const { userInfo } = useSelector((state) => state.user);
//     const location = useLocation();
//     const hideUI = location.pathname.includes("addfield")|| location.pathname.includes("addMinistryField")||location.pathname.includes("addChannelField");
// const churchadmin=userInfo?.roleCode==='17dwer8'

//   return (
//     <div className="App bg-[#191919] ">

//       <Navbar />
//       <div className="flex-1 md:pl-32 md:pt-0 pt-20">
//         <div className="flex flex-col gap-4 h-full p-2">
//           <SearchBar placeholder={"Search"} value={value} onChangeSearchBar={onChangeSearchBar} />
//           <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
//             <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
//               <p className=" text-white text-3xl font-medium">Churches</p>
//               <div className="flex gap-4">
//                 {/* <Link to={"/churches/add"}>
//                   <button className="flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl">
//                     <AiOutlinePlus /> Add Church
//                   </button>
//                 </Link> */}
//                    <button
//                       onClick={() => setIsModalOpen(true)}
//                       className=" flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl "
//                     >
//                       <AiOutlinePlus /> Add Church
//                     </button>
//               </div>
//             </div>
//             <div className="relative bg-[#191919]">

//                     {!isModalOpen?
//               <CustomTable
//                 searchFor="Churches"
//                 heightDesktop={"h-[72vh]"}
//                 width={"w-24"}
//                 // giving extra width to 2nd column
//                 nthChildWidth={
//                   "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(3)]:w-32"
//                 }
//                 notificationTable={true}
//                 data={[]}
//                 headers={allchurchHeader}
//                 customDataFetch={true}
//                 customDataFetchFunction={fetchAllChurches}
//                 reloadData={reloadData}
//                 setReloadData={setReloadData}
//                 handleDeleteClick={(row) => {
//                   const options = {
//                     customUI: ({ onClose }) => {
//                       return (
//                         <ConfirmToast
//                           title="Are you sure?"
//                           message="You want to delete this Church?"
//                           onClose={() => {
//                             onClose();                      // call the original close function
//                           }}
//                           reloadData={reloadData}
//                           onSuccess={async () => {
//                             try {
//                               await handleDelete(row);
//                               setReloadData((prev) => !prev);
//                               onClose();
//                             } catch (err) {
//                               onClose();
//                             }
//                           }}
//                         />
//                       );
//                     },
//                     closeOnEscape: true,
//                     closeOnClickOutside: true,
//                     keyCodeForClose: [8, 32],
//                     overlayClassName: "!bg-gray-500 !bg-opacity-75",
//                   };

//                   confirmAlert(options);

//                 }}
//                 reverseTable={true}
//                 nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
//                 handleToggleClick={(row, isActive) => {
//                 }}
//                 handleEyeClick={(row) => {
//               //  setIsModalOpen(true)
//               //  setSelectedRow(row);
//                // store clicked row
//                   navigate(`/addfield`, {
//                     state: {
//                       church: row || "",
//                     },
//                   });
//                 }}
//                 handleEditClick={(row) => {
//               //  setIsModalOpen(true)
//               //  setSelectedRow(row);
//                // store clicked row
//                   navigate(`/addfield`, {
//                     state: {
//                       church: row || "",
//                     },
//                   });
//                 }}
//               />
//               :''
// }
//             </div>
//     <ChurchModal isOpen={isModalOpen}    onClose={() => { setIsModalOpen(false); setSelectedRow(null); }} rowData={selectedRow} // ✅ pass clicked row
//     />

//           </div>
//          </div>
//       </div>
//      </div>
//   );
// }

// export default AllVideos;

import React, { useState, useCallback, useEffect } from "react";
import SearchBar from "../../components/universal/SearchBar";
import { allchurchHeader } from "./Constants";
import CustomTable from "../../components/universal/CustomTable";
import { AiOutlinePlus } from "react-icons/ai";
import { FaRegStar, FaStar } from "react-icons/fa6";
import { useNavigate, useLocation } from "react-router-dom";
import { AllChurchHooks } from "./hooks/Churchhooks";
import Navbar from "../../components/universal/Navbar";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ConfirmToast from "../../components/universal/ConfirmToast";
import { useSelector, useDispatch } from "react-redux";
import ChurchModal from "./ChurchModal";
import { updateChurchRequest } from "../../store/Churches/actions"; // Adjust path as needed
import { toast } from "react-toastify";
import { SUPER_ADMIN } from "../Users/Constants";

function AllVideos() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { value, onChangeSearchBar, handleDelete, reloadData, setReloadData, fetchAllChurches } =
    AllChurchHooks();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [featuredChurches, setFeaturedChurches] = useState(new Set());
  const [churchOptions, setChurchOptions] = useState([]);
  const [selectedChurchId, setSelectedChurchId] = useState("");
  const { userInfo } = useSelector((state) => state.user);
  const isSuperAdmin = userInfo?.roleCode === SUPER_ADMIN;
  const location = useLocation();
  const hideUI = location.pathname.includes("addfield") || location.pathname.includes("addMinistryField") || location.pathname.includes("addChannelField");
  const tableHeaders = isSuperAdmin
    ? allchurchHeader
    : allchurchHeader.filter((header) => header.headerId !== "featuredColumn");

  // Initialize featured churches from data
  useEffect(() => {
    // This will be called when reloadData changes
    if (reloadData) {
      // Reset featuredChurches to empty set, it will be repopulated when fetchAllChurchesWithStars is called
      setFeaturedChurches(new Set());
    }
  }, [reloadData]);

  // Update church with featured status
  const updateChurchWithFeatured = useCallback((churchData, isFeatured) => {
    return new Promise((resolve, reject) => {

      // Clean description function (similar to your handleUpdateChurch)
      const cleanDescription = (html) => {
        if (!html) return html;

        let cleaned = html.replace(/style="[^"]*background-color[^;"]*;?[^"]*"/gi, '');
        cleaned = cleaned.replace(/style='[^']*background-color[^;']*;?[^']*'/gi, '');
        cleaned = cleaned.replace(/style="[^"]*color[^;"]*;?[^"]*"/gi, '');
        cleaned = cleaned.replace(/style='[^']*color[^;']*;?[^']*'/gi, '');
        cleaned = cleaned.replace(/style=""/gi, '');
        cleaned = cleaned.replace(/style=''/gi, '');
        cleaned = cleaned.replace(/style="[^"]*font-family[^;"]*;?[^"]*"/gi, '');
        cleaned = cleaned.replace(/<span[^>]*background-color[^>]*>/gi, '<span>');

        return cleaned;
      };

      // Build payload using the exact fields from your console data
      const payload = {
        _id: churchData?._id || "",
        churchName: churchData?.churchName || churchData?.church_name || "",
        tagline: churchData?.tagline || churchData?.church_tagline || "",
        description: cleanDescription(churchData?.description || churchData?.church_description || ""),
        logourl: churchData?.logourl || churchData?.logo_url || "",
        address: churchData?.address || churchData?.church_address || "",
        latitude: churchData?.latitude || churchData?.church_latitude || "",
        longitude: churchData?.longitude || churchData?.church_longitude || "",
        contactemail: churchData?.contactemail || churchData?.church_email || "",
        contactphone: churchData?.contactphone || churchData?.church_phone || "",
        website: churchData?.website || churchData?.church_website || "",
        featured: isFeatured, // Add the featured field
      };


      const callback = (res) => {
        if (res.type === 1) {
          toast.success(isFeatured ? "Church added to featured!" : "Church removed from featured!");
          resolve(res);
        } else {
          toast.error("Failed to update featured status");
          reject(res);
        }
      };

      // Dispatch update request
      dispatch(updateChurchRequest(payload, callback));
    });
  }, [dispatch]);

  // Handle star click - updates the church via API
  const handleStarClick = useCallback((church) => {
        const churchId = church._id; // Use _id from your data
    const isCurrentlyFeatured = featuredChurches.has(churchId);
    const newFeaturedStatus = !isCurrentlyFeatured;


    // Update local state immediately for responsive UI
    setFeaturedChurches(prev => {
      const newSet = new Set(prev);
      if (newSet.has(churchId)) {
        newSet.delete(churchId);
              } else {
        newSet.add(churchId);
              }
      return newSet;
    });

    // Call API to update featured status
    updateChurchWithFeatured(church, newFeaturedStatus)
      .then(() => {
                // Refresh table data to show updated state
        setTimeout(() => {
          setReloadData(prev => !prev);
        }, 500);
      })
      .catch((error) => {
                // Revert local state if API call fails
        setFeaturedChurches(prev => {
          const newSet = new Set(prev);
          if (newSet.has(churchId)) {
            newSet.delete(churchId);
          } else {
            newSet.add(churchId);
          }
          return newSet;
        });
      });
  }, [featuredChurches, updateChurchWithFeatured, setReloadData]);

  // Helper function to clean row data (remove React elements)
  const cleanRowData = useCallback((row) => {
    if (!row) return row;

    const cleanRow = { ...row };

    // Remove the featuredColumn if it exists (it contains React elements)
    if (cleanRow.featuredColumn) {
      delete cleanRow.featuredColumn;
    }

    // Remove any other React elements
    Object.keys(cleanRow).forEach(key => {
      const value = cleanRow[key];
      if (value && typeof value === 'object' && value.$$typeof) {
        delete cleanRow[key];
      }
    });

    // Also remove the isFeatured property we added
    if (cleanRow.isFeatured) {
      delete cleanRow.isFeatured;
    }

    return cleanRow;
  }, []);

  // Create a wrapper function that adds interactive stars to the data
  const fetchAllChurchesWithStars = useCallback((page, limit, searchCriteria = {}, callbackFn, churchId) => {

    // Call the original fetchAllChurches with our custom callback
    fetchAllChurches(page, limit, searchCriteria, (response) => {

      if (response?.data && Array.isArray(response.data)) {
        setChurchOptions(response.data);
        localStorage.setItem("churchOptions", JSON.stringify(response.data));
        if (!selectedChurchId && response.data.length > 0) {
          const firstId = response.data[0]?._id || "";
          setSelectedChurchId(firstId);
          if (firstId) {
            localStorage.setItem("church", JSON.stringify(response.data[0]));
            window.dispatchEvent(new CustomEvent("church:change", { detail: response.data[0] }));
          }
        }
        // First, update featuredChurches based on API response
        const newFeaturedSet = new Set();
        response.data.forEach(church => {
          // Check if church has featured property in API response
          if (church.featured === true) {
            const churchId = church._id;
            newFeaturedSet.add(churchId);
          }
        });

        // Update state if there are featured churches from API
        if (newFeaturedSet.size > 0) {
          setFeaturedChurches(newFeaturedSet);
        }

        // Transform the data to add interactive stars
        const transformedData = response.data.map(church => {
          const churchId = church._id;
                    // Check both local state and API response for featured status
          const isFeatured = church.featured ;


          return {
            ...church,
            // Store the featured status as a boolean
            isFeatured: isFeatured,
            ...(isSuperAdmin
              ? {
                  featuredColumn: (
                    <div
                      className="flex justify-center items-center w-full cursor-pointer"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleStarClick(church);
                      }}
                      title={isFeatured ? "Remove from featured" : "Add to featured"}
                    >
                      {isFeatured ? (
                        <FaStar className="text-[#EFBC51] text-xl transition-colors duration-200" />
                      ) : (
                        <FaRegStar className="text-gray-400 text-xl hover:text-[#EFBC51] transition-colors duration-200" />
                      )}
                    </div>
                  ),
                }
              : {})
          };
        });


        // Call the original callback with transformed data
        if (callbackFn) {
          callbackFn({
            ...response,
            data: transformedData
          });
        }
      } else {
                if (callbackFn) {
          callbackFn(response);
        }
      }
    }, churchId);
  }, [fetchAllChurches, featuredChurches, handleStarClick, isSuperAdmin, selectedChurchId]);

  const handleChurchSelect = (churchId) => {
    setSelectedChurchId(churchId);
    const selected = churchOptions.find((c) => c?._id === churchId);
    if (selected) {
      localStorage.setItem("church", JSON.stringify(selected));
      window.dispatchEvent(new CustomEvent("church:change", { detail: selected }));
    }
  };

  return (
    <div className="App bg-[#191919] ">
      <Navbar />
      <div className="flex-1 md:pl-32 md:pt-0 pt-20">
        <div className="flex flex-col gap-4 h-full p-2">
          <SearchBar
            placeholder={"Search"}
            value={value}
            onChangeSearchBar={onChangeSearchBar}
            showChurchDropdown={true}
            churchOptions={churchOptions}
            selectedChurchId={selectedChurchId}
            onChangeChurch={handleChurchSelect}
          />
          <div className="MAIN-CONTENT flex-1 flex flex-col h-full gap-4">
            <div className="flex w-full justify-between md:items-center md:flex-row flex-col gap-4 md:mb-0 mb-2">
              <p className=" text-white text-3xl font-medium">Churches</p>
              <div className="flex gap-4">
              <button
                onClick={() => {
                  localStorage.removeItem("church");
                  window.dispatchEvent(new CustomEvent("church:change", { detail: null }));
                  navigate("/addfield", { state: { church: null, mode: "create" } });
                }}
                // onClick={() => setIsModalOpen(true)} // Commented out as requested
                className=" flex items-center gap-2 text-[13px] text-yellowish border px-4 py-2 border-yellowish bg-blackish rounded-xl "
              >
                <AiOutlinePlus /> Add Church
              </button>
              </div>
            </div>
            <div className="relative bg-[#191919]">
              {!isModalOpen ?
                <CustomTable
                  searchFor="Churches"
                  heightDesktop={"h-[72vh]"}
                  width={"w-24"}
                  // Update nthChildWidth to accommodate the new star column
                  nthChildWidth={
                    isSuperAdmin
                      ? "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-40 [&>*:nth-child(4)]:w-32 [&>*:nth-child(5)]:w-20 [&>*:nth-child(6)]:w-32"
                      : "[&>*:nth-child(1)]:w-40 [&>*:nth-child(2)]:w-40 [&>*:nth-child(3)]:w-32 [&>*:nth-child(4)]:w-20"
                  }
                  notificationTable={true}
                  data={[]}
                  headers={tableHeaders}
                  customDataFetch={true}
                  customDataFetchFunction={fetchAllChurchesWithStars}
                  reloadData={reloadData}
                  setReloadData={setReloadData}
                  handleDeleteClick={(row) => {
                    const cleanRow = cleanRowData(row);

                    const options = {
                      customUI: ({ onClose }) => {
                        return (
                          <ConfirmToast
                            title="Are you sure?"
                            message="You want to delete this Church?"
                            onClose={() => {
                              onClose();
                            }}
                            reloadData={reloadData}
                            onSuccess={async () => {
                              try {
                                await handleDelete(cleanRow);
                                setReloadData((prev) => !prev);
                                onClose();
                              } catch (err) {
                                                                onClose();
                              }
                            }}
                          />
                        );
                      },
                      closeOnEscape: true,
                      closeOnClickOutside: true,
                      keyCodeForClose: [8, 32],
                      overlayClassName: "!bg-gray-500 !bg-opacity-75",
                    };

                    confirmAlert(options);
                  }}
                  reverseTable={true}
                  nthChildStyle={"[&>*:nth-child(2)]:h-5 [&>*:nth-child(2)]:overflow-hidden"}
                  handleToggleClick={(row, isActive) => {
                                      }}
                  handleEyeClick={(row) => {
                    const cleanRow = cleanRowData(row);

                    navigate(`/addfield`, {
                      state: {
                        church: cleanRow || "",
                      },
                    });
                  }}
                  handleEditClick={(row) => {
                    const cleanRow = cleanRowData(row);
                                        navigate(`/addfield`, {
                      state: {
                        church: cleanRow || "",
                      },
                    });
                  }}
                />
                : ''
              }
            </div>
            <ChurchModal
              isOpen={isModalOpen}
              onClose={() => {
                setIsModalOpen(false);
                setSelectedRow(null);
                setReloadData(prev => !prev);
              }}
              rowData={selectedRow}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllVideos;
